'use client';

import { createContext } from 'react';

import { type AbTastyTestsOnPage } from '../ab-tasty';

export const AbTastyContext = createContext<AbTastyTestsOnPage | null>(null);
